<template>
    <Fragment>
        <slot></slot>
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
    components: {
        Fragment
    }
}
</script>

<style>

</style>